var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPostFailed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 24,
    viewBox: "0 0 34 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 0C0.895431 0 0 0.895429 0 2V19.4286C0 20.5331 0.89543 21.4286 2 21.4286H28C29.1046 21.4286 30 20.5331 30 19.4286V2C30 0.895431 29.1046 0 28 0H2ZM26.25 3.89648H15.9375V17.5328H26.25V3.89648ZM3.75 3.89648H14.0625V5.84454H3.75V3.89648ZM14.0625 7.79192H3.75V9.73997H14.0625V7.79192ZM3.75 11.6884H14.0625V13.6365H3.75V11.6884ZM14.0625 15.5849H3.75V17.5329H14.0625V15.5849Z",
    fill: "#FF892A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28 24C31.3137 24 34 21.3137 34 18C34 14.6863 31.3137 12 28 12C24.6863 12 22 14.6863 22 18C22 21.3137 24.6863 24 28 24Z",
    fill: "#52ACBC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.1503 19.4355C24.7598 19.8261 24.7598 20.4592 25.1503 20.8498C25.5408 21.2403 26.174 21.2403 26.5645 20.8498L28.0003 19.414L29.436 20.8498C29.8266 21.2403 30.4597 21.2403 30.8502 20.8498C31.2408 20.4592 31.2408 19.8261 30.8502 19.4355L29.4145 17.9998L30.8502 16.564C31.2408 16.1735 31.2408 15.5404 30.8502 15.1498C30.4597 14.7593 29.8266 14.7593 29.436 15.1498L28.0003 16.5856L26.5645 15.1498C26.174 14.7593 25.5408 14.7593 25.1503 15.1498C24.7598 15.5404 24.7598 16.1735 25.1503 16.564L26.5861 17.9998L25.1503 19.4355Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPostFailed);
export default __webpack_public_path__ + "static/media/post-failed.c00b4b4bf879a4fb0a1e3691edbb4af1.svg";
export { ForwardRef as ReactComponent };